<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3" >
            <!-- Breadcrumb Section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between aline-items-center">
                    <div class="breadcrumbnew">
                        <div @click="$router.go(-1)">CR Dashboard</div>
                    </div>

                    <div class= "d-flex justify-content-between align-items-center">
                        <el-dropdown trigger="click" class="ml-2">
                            <a href="javascript:;" class="btn btn-new-green btn-wide">+ Create Call Report</a>
                            <el-dropdown-menu slot="dropdown" class="mr-2">
                                <!-- <el-dropdown-item v-for="(category, index) in call_report_category_options"
                                    :key="index" @click.native="addCallReport(category)">{{ category }}
                                </el-dropdown-item> -->
                                <el-dropdown-item @click.native="addCallReport('External Meeting')">External Meeting</el-dropdown-item>
                                <el-dropdown-item @click.native="addCallReport('Internal Meeting')">Internal Meeting</el-dropdown-item>
                                <el-dropdown-item @click.native="addCallReport('Review Meeting')">Review Meeting</el-dropdown-item>
                                <el-dropdown-item @click.native="addCallReport('Sales Meeting')">Sales Meeting</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <!-- Recent Call Reports Section -->
                <div class="col-lg-7 col-md-7 col-sm-12 p-0 pl-4">
                    <fullscreen ref="report" @change="dataChange('report')" class="box-radius bg-white">
                        <div class="card-item deals-cards bg-white text-auto pb-0 pt-5" id="salesList">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14 px-5 col-lg-8 col-md-7 col-sm-6 pt-2">Recent Generated Report</div>
                                <div class="col-lg-4 col-md-5 col-sm-6" style="text-align: -webkit-right;">
                                    <a href="javascript:;" class="btn btn-new-primary btn-des" style="margin-right: 5px;"
                                        @click="showFilter()">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg"
                                            alt="filter" style="margin-right: 8px;" />Filter
                                    </a>

                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('report') , addClass()">
                                        <img id="salesExpandImg" class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                            </div>
                            <div class="list-align">
                                <div id="salesValue" class="mt-3 ">
                                    <table class="table-properties team-listview-table text-center w-100">
                                        <thead v-if="reportListData.length != 0">
                                            <tr>
                                                <th>
                                                    <!-- <el-tooltip class="item" effect="dark" content="View" placement="top">
                                                        <button class="btn-icon pt-3"   style="padding:0px!important;">
                                                            <i class="icon icon-eye eyeIcon item text-white iconsize-18" style="margin-right: 13px;"></i>
                                                        </button>
                                                    </el-tooltip> -->
                                                </th>
                                                <th class="text-left">TITLE NAME</th>
                                                <th class="text-left">CALL REPORT TYPE</th>
                                                <th class="text-left">AUTHOR</th>
                                                <!-- <th class="text-left">CUSTOMER</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="w-100" v-if="ajaxCallInProgress">
                                                <td colspan="4">
                                                    <div class="d-flex align-items-center justify-content-center w-100"
                                                        v-if="ajaxCallInProgress">
                                                        <half-circle-spinner :animation-duration="1000" :size="50"
                                                            color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else-if="!ajaxCallInProgress && reportListData.length == 0" class="text-center">
                                                <td colspan="4">
                                                    <img src="/static/images/territory-sales.png" class="mb-3 response-list"/>
                                                    <div class="text-center mt-10 text-muted fw-500">No Recent Reports generated!</div>
                                                </td>
                                            </tr>
                                            <tr v-else v-for="(report_data, index) in reportListData" :key="index" :track-by="report_data.order">
                                                <td>
                                                    <el-tooltip class="item" effect="dark" content="View" placement="top">
                                                            <button class="btn-icon pt-3" style="padding:0px!important;" @click="viewSendCallReport(report_data._id)">
                                                                <i class="icon icon-eye eyeIcon item text-black iconsize-18" style="margin-right: 13px;"></i>
                                                            </button>
                                                    </el-tooltip>
                                                </td>
                                                <td :title="report_data.title_name.value || '-'" class="text-left text-truncate cust-max-width">{{report_data.title_name.value}}</td>
                                                <td :title="report_data.call_report_type.value || '-'" class="text-left text-truncate cust-max-width">{{report_data.call_report_type.value}}</td>
                                                <td :title="report_data.author.value || '-'" class="text-left text-truncate cust-max-width">{{report_data.author.value}}</td>
                                                <!-- <td :title="report_data.customer.value || '-'" class="text-left"> {{report_data.customer.value}}</td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Report Generated Section -->
                <div class="col-lg-5 col-md-5 col-sm-12 pr-4">
                    <div class="col-lg-12 col-sm-12 col-md-12 p-0">
                        <fullscreen ref="sales_generate" @change="dataChange('sales_generate')" class="box-radius bg-white">
                            <div class="p-3">
                                <div class="d-flex justify-content-between aline-items-center mt-3">
                                    <div class="fw-600 fs-14">Report Generated</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('sales_generate') , addClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                        <input type="text" :value="('0'+new Date(dateRange[0]).getMonth()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getDate()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getMonth()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getDate()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()" style="color: #fff; background: #41b883; width: 14em;" disabled />
                                        <span @click="dataClose('report'),dateRange= []" style="color: #fff; cursor: pointer;">&#10005;</span>
                                    </div>
                                </div>
                                <date-picker v-else @change="updatecreationDate()" v-model="dateRange" format="MM/DD/YYYY"
                                     range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"
                                    :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                                </date-picker>
                            </div>
                            <div class="card-item bg-white text-auto pb-0">
                                <div>
                                    <div class="d-flex align-items-center justify-content-center" v-if="reportGeneratedLoader" style="height: 272px;">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div v-else class="col-lg-12">
                                        <div id="salesDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Daily Report based on report type Section -->
                    <div class="col-lg-12 col-sm-12 col-md-12 mt-4 p-0">
                        <fullscreen ref="report_generate" @change="dataChange('report_generate')" class="box-radius bg-white">
                            <div class="p-3">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Daily Report based on Report Type</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('report_generate') , addClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div v-if="dateReportRange.length" style="border-bottom: 1px solid #a9aaad;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                        <input type="text" :value="('0'+new Date(dateReportRange[0]).getMonth()).slice(-2)+'/'+('0'+(new Date(dateReportRange[0]).getDate()+1)).slice(-2)+'/'+new Date(dateReportRange[0]).getFullYear()+' to '+('0'+new Date(dateReportRange[1]).getMonth()).slice(-2)+'/'+('0'+(new Date(dateReportRange[1]).getDate()+1)).slice(-2)+'/'+new Date(dateReportRange[1]).getFullYear()" style="color: #fff; background: #41b883; width: 14em;" disabled />
                                        <span @click="dataClose('type'), dateReportRange= []" style="color: #fff; cursor: pointer;">&#10005;</span>
                                    </div>
                                </div>
                                <date-picker v-else @change="updateReportDate()" v-model="dateReportRange" format="MM/DD/YYYY"
                                     range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"
                                    :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                                </date-picker>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadDailyReportSection" style="height: 414px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="card-item bg-white text-auto pb-0">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div id="revenueDiv" class="mt-3"></div>
                                         <div id="selectordiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>

                </div>
            </div>
        </div>
        <div v-show="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></filter-data>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    const FilterData = () => import("../Dashboard/CallReportFilters.vue");
    import dashboard from "../mixins/dashboard.js"
    import {HalfCircleSpinner} from "epic-spinners";
    import { EventBus } from '../eventBus/nav-bar-event';
    import { SweetModal } from 'sweet-modal-vue';
    import convert from "../mixins/convert.js";
    export default {
        data() {
            return {
                loadDailyReportSection: false,
                reportGeneratedLoader: false,
                call_report_category_options: [],
                currency:'',
                graph_scale:[],
                graph_scale: [],
                generated_type: [],
                ajaxCallInProgress: false,
                warning_msg: '',
                success_msg: '',
                pageLimit: [],
                total: 0,
                skip: 0,
                limit: 10,
                start: 0,
                end: 0,
                count: 0,
                searchKey: '',
                show: false,
                chart: {},
                selected_type: "today",
                reportListData:[],
                select_month: null,
                open: false,
                time_period: 'FiscalYear',
                period_options: ['FiscalYear', 'Semi-Annual', 'Quarter', 'Month'],
                semi_options: ['H1', 'H2'],
                quarter_options: ['Q1', 'Q2', 'Q3', 'Q4'],
                filter: false,
                hide_filters: false,
                display_filters: false,
                date_from:"2022-01-01",
                date_to:"2022-05-05",
                sales_generated_data: [],
                showfilterData: {
                    author_name: [],
                    branch: [],
                    call_report_category: [],
                    created_date: null,
                    customer: [],
                    location: [],
                    department: [],
                    meeting_type: [],
                    title_name: [],

                },
                created_report_date: [new Date() , new Date()],
                rangeDate: [],
                dateRange: [],
                dateReportRange: [],
                creation_date: [],
                pickerOptions:{
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    }
                },
                lang: {
                    type: "en",
                    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    months: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    pickers: [
                        "next 7 days",
                        "next 30 days",
                        "previous 7 days",
                        "previous 30 days"
                    ],
                    placeholder: {
                        date: "Select Date",
                        dateRange: "Select Date Range",
                        dateReportRange:"Select Date Range"
                    },

                },
            }
        },
        components: {
            FilterData,
            HalfCircleSpinner,
            SweetModal
        },
        mixins:[dashboard,convert],
        methods: {
            //get the call report type
            // getCallReportType() {
            //     this.$http.get("/call_report/get_call_report_category").then(res => {
            //         if (res.data.status_id == 1) {
            //             res.data.response.value.forEach(x => {
            //                 this.call_report_category_options.push(x.name);
            //             });
            //         }
            //     });
            // },
            //add the cnew call reprot baseon the category
            /**@params = category */
            addCallReport(category) {
                this.$store.commit("setCallReportCategory", category);
                this.$router.push("/callreport");
            },
            //convert the date format and call api based on the value
            /**@params = val */
            dataClose(val){
                let date = this.rangeDate
                let start_date = this.convertFilter(date[0])
                let end_date = this.convertFilter(date[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                if(val == 'report'){
                    this.loadCallReportSalesGeneratedDataAPI();
                } else{
                    this.loadDailyReportDataAPI();
                }
            },
            //Set the date
            dateSettings(){
                let date = []
                var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
                var newDate = this.convertFilter(new Date());
                var oldDate = new Date();
                oldDate.setTime(oldDate.getTime() - dateOffset);
                this.created_report_date= [this.convertFilter(oldDate),newDate]
                this.rangeDate = [this.convertFilter(oldDate),newDate]
            },
            //udpate the creation date value and convert the date format
            updatecreationDate(){
                if (this.dateRange) {
                    let start_date = this.convertFilter(this.dateRange[0])
                    let end_date = this.convertFilter(this.dateRange[1])
                    let newValue = start_date + ',' + end_date
                    newValue = newValue.split(",")
                    this.created_report_date = newValue
                    this.loadCallReportSalesGeneratedDataAPI()
                } else {
                    this.creation_date = []
                    this.created_report_date = []
                }
                this.$forceUpdate()

            },
            //udpate the report date value and convert the date format
            updateReportDate(){
                if (this.dateReportRange) {
                    let start_date = this.convertFilter(this.dateReportRange[0])
                    let end_date = this.convertFilter(this.dateReportRange[1])
                    let newValue = start_date + ',' + end_date
                    newValue = newValue.split(",")
                    this.created_report_date = newValue
                    this.loadDailyReportDataAPI()
                } else {
                    this.creation_date = ''
                    this.created_report_date = ''
                }
                this.$forceUpdate()

            },
            //view the  callreport data
            /**@params = callReport_id */
            viewSendCallReport(callReport_id) {
                if(this.userPermissions.call_reports.permitted_actions.view || this.userPermissions.draft_call_reports.permitted_actions.view){
                    this.$router.push("/viewcallreport/" + callReport_id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //remvoe the chips added
            /**@params = value, @params = key */
            removeChips(value,key){
                let params = {
                    value:value,
                    key:key
                }
                EventBus.$emit('removechip',params)
            },
            //remove all chips
            removeAllChips(){
                this.filters = {
                    author_name: [],
                    call_report_category: [],
                    created_date: [],
                    customer: [],
                    meeting_type: [],
                    title_name: "",
                }
                this.showfilterData = {
                    author_name: [],
                    call_report_category: [],
                    created_date: [],
                    customer: [],
                    meeting_type: [],
                    title_name: "",
                }
                EventBus.$emit('removeAllchip')
                if(!this.display_filters) {
                    EventBus.$emit("load_customers",this.filters)
                }
            },
            //udpte the filter data
            /**@params = params */
            UpdateByFilter(params) {
                this.skip = 0
                this.limit = 10
                this.showfilterData = {
                    author_name: params.value1.author_name,
                    call_report_category: params.value1.call_report_category,
                    created_date: params.value1.created_date,
                    customer: params.value1.customer,
                    title_name: params.value1.title_name,
                    company_name: this.company_name,
                }
                let meeting_date = []
                this.filters = {
                    author_name: params.value1.author_name,
                    call_report_category: params.value1.call_report_category,
                    created_date: params.value1.created_date,
                    customer: params.value1.customer,
                    title_name: params.value1.title_name,
                    company_name: this.company_name,
                }
                if (params.value1.customer.length) {
                    Object.assign(this.filters.customer, {
                        customer: params.value1.customer,
                    });
                    this.filters.customer.forEach((x, index) => {
                        this.filters.customer[index] = x.customer_name ? x.customer_name :x;
                    });
                }
                if (params.value1.author_name.length) {
                    Object.assign(this.filters.author_name, {
                        author_name: params.value1.author_name,
                    });
                    this.filters.author_name.forEach((x, index) => {
                        this.filters.author_name[index] = x.full_name? x.full_name :x;
                    });
                }
                let meetingDate = {}
                if (params.value1.created_date.length) {
                    Object.assign(meetingDate, {

                        start_date: ("0" + new Date(params.value1.created_date[0]).getDate()).slice(-2) + "/" + (
                                "0" + (new Date(params.value1.created_date[0]).getMonth() + 1)).slice(-2) + "/" +
                            new Date(params.value1.created_date[0]).getFullYear(),
                        end_date: ("0" + new Date(params.value1.created_date[1]).getDate()).slice(-2) + "/" + ("0" +
                                (new Date(params.value1.created_date[1]).getMonth() + 1)).slice(-2) + "/" +
                            new Date(params.value1.created_date[1]).getFullYear(),

                    });


                }
                this.filters.created_date = meetingDate
                this.getCallReportData()
            },
            //hide the filter modal
            hideFilters() {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            },
            //show the filter modal
            showFilter() {
                if (this.display_filters) {
                    this.hide_filters = true
                    setTimeout(() => {
                        this.display_filters = false
                        this.hide_filters = false
                    }, 500);
                } else {
                    this.display_filters = true
                }
            },
            handleChange(value, type) {
                if (type === 'second') {
                    this.open = false;
                }
            },
            display() {
                this.show = !this.show
            },
            //get the call reprot data list
            async getCallReportData() {
                this.ajaxCallInProgress = true
                try {
                    /**@params = search_key, @params= limit, @params = skip, @params= filter_json */
                    let params = {
                        search_key: this.searchKey,
                        limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                        skip: this.skip,
                        filter_json: this.filters,
                    };
                    let response = await this.getCallReportsList(params)
                    if (response.status_id == 1 && this.searchKey == response.search_key) {

                        this.reportListData = [];
                        response.response.forEach((x, index) => {
                            this.reportListData.push({
                                _id: x._id,
                                title_name: {
                                    value: x.title || "-",
                                    order: 1,
                                },
                                call_report_type: {
                                    value: x.call_report_type || "-",
                                    order: 2,
                                },
                                author: {
                                    value: x.author_name || "-",
                                    order: 3,
                                },
                                customer: {
                                    value: x.external_attendees && x.external_attendees.length ? x
                                        .external_attendees[0].company_name || "-" : "-",
                                    order: 4,
                                },
                            });
                        });

                    }
                } catch(error) {
                }
                this.ajaxCallInProgress = false
            },
            //Api call to load the daily report data
            async loadDailyReportDataAPI(){
                this.loadDailyReportSection = true;
                try {
                    /**@params = params */
                    let params ={
                        range: this.created_report_date
                    }
                    let response = await this.getDailyReportData(params)
                    this.generated_type = response.response.timing
                    const result = []
                    //Added multiple category and multiple data
                    for (const item of this.generated_type) {
                        result.push({
                            category: item.concat_time
                        });
                        let index_of_p_cat = result.findIndex(object => {
                            return object.category === item.concat_time;
                            });
                        item.category.forEach((element, index)=>{

                        result[index_of_p_cat]['value'+(index + 1)] = element.count;
                        })
                    }
                    this.generated_type = result
                    this.graph_scale = response.response.graph_scale
                    let illustrator = response.response.is_illustrator
                    const scale = []
                    for (const scaledata of this.graph_scale) {
                        scale.push(scaledata)
                    }
                    this.graph_scale = scale
                    if(illustrator == true ){
                        setTimeout(() => {
                        this.loadDailyReportSection = false;
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            style.innerHTML = '.revClass { width: 50%!important;height: 60%!important;margin:auto!important;margin-top:45px !important}';
                            document.getElementsByTagName('head')[0].appendChild(style);
                            document.getElementById('revenueDiv').innerHTML = "<div class=text-center mt-4><img id=rev-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No history of daily reports yet!</div></div>";
                            document.getElementById('rev-img').className = 'revClass';
                        }, 1000);
                    } else {
                        this.loadDailyReportSection = false;
                        this.loadDailyReportData();
                    }
                    this.loadDailyReportSection = false;
                } catch (reason) {
                    this.loadDailyReportSection = false;
                }
            },
            //load daily report data
            loadDailyReportData() {
                setTimeout(() => {
                    let vueThis = this;
                    am4core.useTheme(am4themes_animated);
                    var chart = am4core.create("revenueDiv", am4charts.XYChart);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                    chart.data = vueThis.generated_type;

                    chart.colors.step = 2;
                    chart.padding(30, 30, 10, 30);
                    chart.legend = new am4charts.Legend();

                    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "category";
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.title.text = "Time"
                    categoryAxis.title.fontWeight = 600;
                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.min = 0;
                    valueAxis.max = 100;
                    valueAxis.strictMinMax = true;
                    valueAxis.calculateTotals = true;
                    valueAxis.renderer.minWidth = 50;
                    valueAxis.numberFormatter.numberFormat = "#a";
                    valueAxis.title.text = "No. of Reports"
                    valueAxis.title.fontWeight = 600;
                    var series1 = chart.series.push(new am4charts.ColumnSeries());
                    series1.columns.template.width = am4core.percent(80);
                    series1.columns.template.tooltipText = "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    series1.name = "External Meeting";
                    series1.dataFields.categoryX = "category";
                    series1.dataFields.valueY = "value1";
                    series1.dataFields.valueYShow = "totalPercent";
                    series1.dataItems.template.locations.categoryX = 0.5;
                    series1.stacked = true;
                    series1.tooltip.pointerOrientation = "vertical";
                    var bullet1 = series1.bullets.push(new am4charts.LabelBullet());
                    bullet1.interactionsEnabled = false;
                    bullet1.label.text = "{valueY}";
                    bullet1.label.fill = am4core.color("#ffffff");
                    bullet1.locationY = 0.5;
                    var series2 = chart.series.push(new am4charts.ColumnSeries());
                    series2.columns.template.width = am4core.percent(80);
                    series2.columns.template.tooltipText =
                    "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    series2.name = "Internal Meeting";
                    series2.dataFields.categoryX = "category";
                    series2.dataFields.valueY = "value2";
                    series2.dataFields.valueYShow = "totalPercent";
                    series2.dataItems.template.locations.categoryX = 0.5;
                    series2.stacked = true;
                    series2.tooltip.pointerOrientation = "vertical";
                    var bullet2 = series2.bullets.push(new am4charts.LabelBullet());
                    bullet2.interactionsEnabled = false;
                    bullet2.label.text = "{valueY}";
                    bullet2.locationY = 0.5;
                    bullet2.label.fill = am4core.color("#ffffff");

                    var series4 = chart.series.push(new am4charts.ColumnSeries());
                    series4.columns.template.width = am4core.percent(80);
                    series4.columns.template.tooltipText =
                    "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    series4.name = "Sales Meeting";
                    series4.dataFields.categoryX = "category";
                    series4.dataFields.valueY = "value4";
                    series4.dataFields.valueYShow = "totalPercent";
                    series4.dataItems.template.locations.categoryX = 0.5;
                    series4.stacked = true;
                    series4.tooltip.pointerOrientation = "vertical";
                    var bullet4 = series4.bullets.push(new am4charts.LabelBullet());
                    bullet4.interactionsEnabled = false;
                    bullet4.label.text = "{valueY}";
                    bullet4.locationY = 0.5;
                    bullet4.label.fill = am4core.color("#ffffff");

                    var series5 = chart.series.push(new am4charts.ColumnSeries());
                    series5.columns.template.width = am4core.percent(80);
                    series5.columns.template.tooltipText =
                    "{name}: {valueY.totalPercent.formatNumber('#.00')}%";
                    series5.name = "Review Meeting";
                    series5.dataFields.categoryX = "category";
                    series5.dataFields.valueY = "value5";
                    series5.dataFields.valueYShow = "totalPercent";
                    series5.dataItems.template.locations.categoryX = 0.5;
                    series5.stacked = true;
                    series5.tooltip.pointerOrientation = "vertical";
                    var bullet5 = series5.bullets.push(new am4charts.LabelBullet());
                    bullet5.interactionsEnabled = false;
                    bullet5.label.text = "{valueY}";
                    bullet5.locationY = 0.5;
                    bullet5.label.fill = am4core.color("#ffffff");
                    chart.scrollbarX = new am4core.Scrollbar();
                }, 1000);
            },
            //load revenue data
            loadReveuneData() {
                let vueThis = this;
                am4core.useTheme(am4themes_animated);
                var chart = am4core.create("revenueDiv", am4charts.XYChart);
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                chart.data = vueThis.generated_type;

                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "value";
                series.dataFields.dateX = "date";
                series.tooltipText = "{value}"
                series.tooltip.pointerOrientation = "vertical";
            },
            //Api call to get the sales geanrate data
            async loadCallReportSalesGeneratedDataAPI(){
                this.reportGeneratedLoader = true;
                try {
                    /**@params = range */
                    let params = {
                        range : this.created_report_date
                    }
                    let response = await this.getCallReportSalesGeneratedData(params)
                    this.sales_generated_data = response.response.timing
                    const result = []
                    const map = new Map();
                    for (const item of this.sales_generated_data) {
                        map.set(item.count, true);
                        result.push({
                            date: item.concat_time || '',
                            value:item.count
                        });
                    }
                    this.graph_scale = response.response.graph_scale
                    const scale = []
                    for (const scaledata of this.graph_scale) {
                        scale.push(scaledata)
                    }

                    this.graph_scale = scale
                    this.sales_generated_data = result
                    if(this.graph_scale == ''){
                        this.reportGeneratedLoader = false;
                        setTimeout(() => {
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            style.innerHTML = '.cssClass {width: 50%!important;height: 60%!important;margin:auto!important;margin-top:15px !important }';
                            document.getElementsByTagName('head')[0].appendChild(style);
                            document.getElementById('salesDiv').innerHTML = "<div class=text-center mt-4><img id= deal-img src=/static/images/customers.png class=mt-3><div class='mt-4 text-muted fw-500'>No Reports generated!</div></div>";
                            document.getElementById('deal-img').className = 'cssClass';
                        }, 1000);
                    } else {
                        this.reportGeneratedLoader = false;
                        this.loadCallReportSalesGeneratedData();
                    }

                } catch (reason) {
                    this.reportGeneratedLoader = false;
                }
                this.reportGeneratedLoader = false;
            },
            //setting the response into the graph
            loadCallReportSalesGeneratedData() {
                setTimeout(() => {
                    let vueThis = this;
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end

                    var chart = am4core.create("salesDiv", am4charts.XYChart);
                    chart.paddingRight = 40;

                    var data = [];
                    var value = 50;
                    for (let i = -3650; i < 0; i++) {
                    let date = new Date();
                    date.setHours(0, 0, 0, 0);
                    date.setDate(i);
                    value -= Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                    if (value < 0) {
                        value = Math.round(Math.random() * 10);
                    }
                    data.push({ date: date, value: value });
                    }

                    chart.data = this.sales_generated_data;

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 60;
                    dateAxis.groupData = true;
                    dateAxis.title.text = "Time"
                    dateAxis.title.fontWeight = 600;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.title.text = "Report";
                    valueAxis.title.fontWeight = 600;
                    valueAxis.numberFormatter.numberFormat = "#a";


                    //create label
                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{value}";

                    // Create series
                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = "value";
                    series.dataFields.dateX = "date";
                    series.tooltipText = "{value}"

                    series.tooltip.pointerOrientation = "vertical";

                    chart.cursor = new am4charts.XYCursor();

                    chart.scrollbarX = new am4core.Scrollbar();
                }, 1000);
            },
            //expand the data
            /**@params = value */
            expandData(value) {
                if(value == 'report_generate'){
                    this.$refs["report_generate"].toggle();
                    this.addClass()
                } else if(value == 'sales_generate'){
                    this.$refs["sales_generate"].toggle();
                    this.addClass()
                } else if(value == 'report'){
                    this.$refs["report"].toggle();
                    this.addClass()
                }
            },
            //change the data based on the value
            /**@params = value */
            dataChange(value) {
                if(value == 'report_generate'){
                    this.surveytype = value;
                    this.addClass()
                } else if(value == 'sales_generate'){
                    this.sales_generate = value;
                    this.addClass()
                } else if(value == 'report'){
                    this.report = value;
                    this.addClass()
                }
            },
            //add the classes to expand the div size in full screen
            addClass(){
                var revenue = document.getElementById('revenueDiv');
                revenue.classList.toggle('revenueDiv-expand');
                var salesList = document.getElementById('salesList');
                salesList.classList.toggle('salesValue-expand');
                var expand = document.getElementById('salesExpandImg');
                expand.classList.toggle('expandImg');
                var sales = document.getElementById('salesDiv');
                sales.classList.toggle('salesDiv-expand');

            },
        },

        computed: {
            getSkipCount(){
                if(this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip>this.total?this.total:this.skip+1;
                    return skip_count;
                }
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },

        },
        watch: {
            selected_type() {
                if (this.selected_type == 'month') {
                    this.open = true
                } else {
                    this.open = false
                }
            }
        },

        mounted() {
            this.currency = this.loggedInUser.currency.symbol;
            // this.getCallReportType()
            this.dateSettings();
            this.loadDailyReportDataAPI(),
            this.getCallReportData(),
            this.loadCallReportSalesGeneratedDataAPI()
        }
    }
</script>
<style scoped>

    .card-item {
        /* padding: 18px 18px 30px 37px; */
        border-radius: 6px;
    }

    /* .deals-cards {
        padding: 28px !important
    } */
    .team-listview-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 5px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-listview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-listview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }
    .ml-32px {
        margin-left: 32px;
    }
    #leadsDiv {
        width: 100%;
        height: 200px;
    }
    #dealsDiv {
        width: 100%;
        height: 200px;
    }
    #contractDiv {
        width: 100%;
        height: 340px;
    }
    #targetDiv {
        width: 100%;
        height: 340px;
    }
    #salesDiv {
        width: 100%;
        height: 260px;
    }
    .logo-image {
        width: 40px;
        height: 55px;
    }
    .contracts-logo {
        position: relative;
        bottom: 20px;
    }
    .pb-10px {
        padding-bottom: 10px;
    }
    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }
    .meetings {
        border: 1px solid #00448b;
        border-radius: 4px;
        padding-top: 8px;
    }
    #revenueDiv {
        width: 100%;
        height: 360px;
    }
    #salesValue {
        width: 100%;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 810px;
        height: 810px;
        overflow: auto !important;
    }
    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }
    .table-properties {
        border-collapse: collapse;
        width: 100%;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }
    #days {
        cursor: pointer;
    }
    .expand-img {
        width: 20px;
        margin-bottom: 2px;
    }
    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }
    .icon-images {
        width: 24px;
        padding-right: 10px;
    }
    .copy-icon-images {
        width: 30px;
    }
    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }
    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }
    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }
    .contactMedia {
        width: 100%;
        height: 280px !important;
    }
    .scm-filters {
        height :260px!important;
        overflow:auto !important;
    }
    #selectordiv {
        width: 100%;
        height: 30px;
    }
    .calendar-height-top .mx-datepicker-popup {
        top: 0px !important;
        left: 0px !important;
    }
    .response-list{
        width: 70%!important;
		height: 70%!important;
		margin: auto!important;
		margin-top: 200px!important;
    }
    .salesDiv-expand, .revenueDiv-expand,.salesList-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height:90
    }
    .expandImg{
        width:24px !important;
    }
    .loader-div-height{
        height: 290px;
    }
    .list-align{
        margin-left: 0px;
    }
    .cust-max-width{
        max-width: 410px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/CallReportDashboard.vue